import { render, staticRenderFns } from "./PcPcmRegnTable.vue?vue&type=template&id=124c4930&"
import script from "./PcPcmRegnTable.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports